import { combineEpics } from 'redux-observable';

import { findSettingsEpic } from './FindSettings/FindSettingsEpic';
import { updateSettingsEpic } from './UpdateSettings/UpdateSettingsEpic';

export const settingsEpics = combineEpics(
  findSettingsEpic,
  updateSettingsEpic,
);
